import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PropTypes from "prop-types";

const FeatureBlock = ({ title, description, features }) => {
  return (
    <Box
      sx={{
        background: "rgba(255, 255, 255, 0.05)",
        borderRadius: "20px",
        p: { xs: 3, md: 2 },
        mb: { xs: 2, md: 3 },
        border: "1px solid rgba(255, 255, 255, 0.1)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 10px 30px rgba(23, 193, 232, 0.2)",
        },
      }}
    >
      <Typography 
        variant="h5" 
        sx={{ 
          color: " #5BF2FF", 
          fontWeight: "bold", 
          mb: 1.5,
          fontSize: { xs: "1.2rem", md: "1.4rem" },
          fontFamily: "Outfit",
        }}
      >
        {title}
      </Typography>
      
      <Typography 
        variant="body1" 
        sx={{ 
          color: "rgba(255, 255, 255, 0.7)", 
          mb: 2,
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.5,
          fontFamily: "Outfit",
        }}
      >
        {description}
      </Typography>
      
      <List sx={{ flexGrow: 1, p: 0 }}>
        {features.map((feature, index) => (
          <ListItem key={index} disablePadding sx={{ mb: 1.5, alignItems: "flex-start" }}>
            <ListItemIcon sx={{ minWidth: "30px", mt: 0.5 }}>
                <CheckCircleOutlineIcon
                  sx={{ 
                    color: "#FFFFFF", 
                    background: "linear-gradient(45deg, #FFFFFF, #FFFFFF)",
                    borderRadius: "50%",
                    fontSize: { xs: "0.8rem", md: "0.8rem" } 
                  }} 
                />
            </ListItemIcon>
            <ListItemText
              primary={feature}
              primaryTypographyProps={{
                sx: { 
                  color: "rgba(255, 255, 255, 0.8)", 
                  fontSize: { xs: "0.85rem", md: "0.95rem" }, 
                  lineHeight: 1.4,
                  fontFamily: "Outfit",
                },
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

FeatureBlock.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default FeatureBlock;
